<main class="mb-4">
  <div class="row ">
    <div class="col-sm-12">
      <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepSender.Cards.SenderContacts.Title' | translate}}</h2>
    </div>
  </div>

  <div class="row " *ngIf="isCommonDataLoaded">

    <!--País-->


    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('countryCode')">
          <label for="country" [ngClass]="{'disabled': isFieldDisabled('countryCode')}">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Country' | translate}}
          </label>
          <select class="custom-select" [(ngModel)]="cardData.countryCode" name="country" #country="ngModel" required
                  (change)="onCountryChanged();"
                  [dropdownTitle]="{value : cardData.countryCode, dimensions :  countries }"
                  nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of countries" [value]="domain.code">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="country"></validation-message>
        </fieldset>
      </div>
    </div>

    <!--Morada-->
    <div class="col-sm-8">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('address')">
          <label for="address" [ngClass]="{'disabled': isFieldDisabled('address')}">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Address' | translate}}
          </label>
          <div class="position-relative">
            <input class="form-control input-right" type="text" [(ngModel)]="cardData.address"
                   #address="ngModel" name="address"
                    maxlength="80"
                   required messageFieldType="string"
                   style='text-transform:uppercase'>

            <validation-message [control]="address"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

  </div>

  <div class="row ">

    <!--Código Postal-->
    <div class="col-sm-4" *ngIf="cardData.countryCode=='PT'">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('postalCodeFirst')  || isServiceOrFunerary?.toString() == 'true'">
          <label for="postalCodeFirst"
                 [ngClass]="{'disabled': isFieldDisabled('postalCodeFirst') || isServiceOrFunerary?.toString() == 'true'}">
            <span class="mandatory">*</span> 
            {{'CardSubscriberContacts.PostalCode' | translate}}
          </label>
          <div class="form-row">
            <div class="col-sm-6">
              <input class="form-control" type="text" numeric="4" placeholder="{{'Placeholders.Generic.PostalCodeFirst4' | translate}}"
                     [(ngModel)]="cardData.postalCodeFirst" name="postalCodeFirst"
                     #postalCodeFirst="ngModel" exactLength="4" required
                     (ngModelChange)="onPostalCodeChanged()">
              <validation-message [control]="postalCodeFirst"></validation-message>
            </div>
            <div class="col-sm-6">
              <input class="form-control" type="text" numeric="3" placeholder="{{'Placeholders.Generic.PostalCodeLast3' | translate}}"
                     [(ngModel)]="cardData.postalCodeLast" name="postalCodeLast"
                     #postalCodeLast="ngModel" exactLength="3" pattern="\d*" required
                     (ngModelChange)="onPostalCodeChanged()">
              <validation-message [control]="postalCodeLast"></validation-message>
            </div>
          </div>
        </fieldset>
      </div>
    </div>


    <!--Código Postal Estrangeiro-->
    <div class="col-sm-4" *ngIf="cardData.countryCode!='PT'">
      <div class="form-group">
        <fieldset>
          <label for="postalCodeFull">
            <span class="mandatory">*</span>
            {{'CardSubscriberContacts.PostalCode' | translate}}
          </label>
          <input class="form-control" type="text" placeholder="{{'Placeholders.Generic.ForeignPostalCode' | translate}}"
                 [(ngModel)]="cardData.postalCodeFull" name="postalCodeFull" #postalCodeFull="ngModel" required maxlength="20">
          <validation-message [control]="postalCodeFull"></validation-message>
        </fieldset>
      </div>
    </div>


    <!--Designação postal-->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="postalDesignation" class="disabled">
          <span class="mandatory">*</span>
          {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.PostalDesignation' | translate}}
        </label>
        <div class="position-relative">
          <input class="form-control input-right" type="text" [(ngModel)]="cardData.postalDesignation"
                 #postalDesignation="ngModel" name="postalDesignation"
                 messageFieldType="string"
                 required
                 disabled>

          <validation-message [control]="postalDesignation"></validation-message>
        </div>
      </div>
    </div>

    <!--Localidade-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('locality')" required>
          <label for="locality" [ngClass]="{'disabled': isFieldDisabled('locality')}">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Locality' | translate}}
          </label>
          <div class="position-relative">
            <input class="form-control input-right" type="text" [(ngModel)]="cardData.locality"
                   #locality="ngModel" name="locality"
                   required messageFieldType="string"
                   style='text-transform:uppercase'>

            <validation-message [control]="locality"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>
  </div>

  <div class="row ">

    <!--Telefone Fixo-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset disabled>
          <label for="telephone" class="disabled">
            <!--<span class="mandatory" *ngIf="!isServiceOrFunerary">*</span>-->
            {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Telephone' | translate}}
          </label>
          <div class="position-relative">
            <input class="form-control input-right" type="text" [(ngModel)]="cardData.telephone"
                   #telephone="ngModel" name="telephone"

                   messageFieldType="string"
                   [pattern]="landlinePattern">

            <validation-message [control]="telephone"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

    <!--Telemóvel-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="cardData.isMobileCertified?.toString()=='true'" >
          <label for="mobilePhone" [ngClass]="{'disabled': cardData.isMobileCertified?.toString()=='true'}">
            <span class="mandatory" *ngIf="!isServiceOrFunerary">*</span>
            {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.MobilePhone' | translate}}
            <button type="button"
                    class="btn-icon text-primary icon-help"
                    aria-label="Tooltip com informação"
                    tooltip="{{'Tooltips.CardSubscriberContacts.MobileNumber' | translate}}"></button>
          </label>
          <div class="position-relative">
            <input class="form-control input-right" type="text" [(ngModel)]="cardData.mobilePhone"
                   #mobilePhone="ngModel" name="mobilePhone"
                   
                   [required]="!isServiceOrFunerary"
                   messageFieldType="string"
                   [pattern]="mobilePattern">

            <validation-message [control]="mobilePhone"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

    <!--E-mail-->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="email" class="disabled">
          <span class="mandatory">*</span>{{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Email' | translate}}
          <button type="button"
                  class="btn-icon text-primary icon-help"
                  aria-label="Tooltip com informação"
                  tooltip="{{'Tooltips.CardSubscriberContacts.Email' | translate}}" disabled></button>
        </label>
        <div class="position-relative">
          <input class="form-control input-right" type="text" [(ngModel)]="cardData.email"
                 #email="ngModel" name="email"
                 placeholder="{{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.EmailPlaceholder' | translate}}"
                 required messageFieldType="string" disabled>

          <validation-message [control]="email"></validation-message>
        </div>
      </div>
    </div>
  </div>


  <div class="row">
    <div class="form-group text-secondary col-sm-12" style="font-size:90%;">
      <label style="display:block">
        {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Messages.PersonalData' | translate}}
      </label>
    </div>
  </div>
</main>
